/**
 * An image node whose `src` is not one of our own origins is drawn as this
 * plain link instead of an `<img>`: the page's Content-Security-Policy would
 * block the image anyway, and loading it would tell a third party who opened
 * the page. See `@/lib/allowed-image-origins` for the allowlist.
 */
export function ExternalImageLink({ href, alt }: { href: string; alt: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer nofollow"
      referrerPolicy="no-referrer"
      onMouseDown={(e) => e.stopPropagation()}
      className="break-all text-accent underline underline-offset-2 hover:opacity-80"
    >
      {alt || href}
    </a>
  )
}
